import { render } from "./CookiesModal.vue?vue&type=template&id=1d5a6113"
import script from "./CookiesModal.vue?vue&type=script&lang=js"
export * from "./CookiesModal.vue?vue&type=script&lang=js"

import "./CookiesModal.vue?vue&type=style&index=0&id=1d5a6113&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__